import {
  COUNTRY_COOKIE,
  SHOP_STORE_CODE_COOKIE,
} from 'dotcom-core/src/constants';

function getCookie(cookieString: string | null, key: string) {
  if (!cookieString) return null;

  const cookies = cookieString.split(';');

  for (const cookie of cookies) {
    const [cookieKey, cookieValue] = cookie.trim().split('=');
    if (cookieKey === key) {
      return cookieValue;
    }
  }

  return null;
}

function getLocalizationCountryCookie(): string {
  const country = getCookie(document.cookie, COUNTRY_COOKIE) || 'US';

  return country;
}

function getShopStoreCodeCookie(): string {
  const country =
    getCookie(document.cookie, SHOP_STORE_CODE_COOKIE) || 'usa_usd_en';

  return country;
}

function getCookieConsent(
  cookieHeader: string | null,
  name = 'OptanonConsent',
): string | null {
  if (!cookieHeader) return null;

  const cookies = cookieHeader.split(';').reduce(
    (acc: Record<string, string>, cookie) => {
      const trimmed = cookie.trim();
      const eqIdx = trimmed.indexOf('=');
      if (eqIdx === -1) return acc;
      const key = trimmed.substring(0, eqIdx);
      // Only split at the first '=' to capture the entire value.
      const value = trimmed.substring(eqIdx + 1);
      acc[key] = value;
      return acc;
    },
    {} as Record<string, string>,
  );

  return cookies[name] || null;
}

function parseCookieConsentGroups(
  cookieString: string | null,
): Record<string, boolean> {
  if (!cookieString) {
    return {
      C0001: true,
      C0002: false,
      C0003: false,
      C0004: false,
    };
  }

  const params = new URLSearchParams(cookieString);
  const groupsStr = params.get('groups');
  if (!groupsStr) {
    return {};
  }

  return groupsStr
    .split(',')
    .reduce((acc: Record<string, boolean>, entry: string) => {
      const [group, value] = entry.split(':');
      acc[group] = value === '1';
      return acc;
    }, {});
}

export {
  getCookie,
  getLocalizationCountryCookie,
  getShopStoreCodeCookie,
  getCookieConsent,
  parseCookieConsentGroups,
};
